import { createSelector } from 'reselect';

const emailTemplates = state => state.emailTemplates;
export const getEmailTemplates = createSelector([emailTemplates], emailTemplates => emailTemplates.templates);
export const getEmailTemplteFields = createSelector([emailTemplates], emailTemplates => emailTemplates.fields);
